module.exports = __webpack_public_path__ + "static/media/eccomerce-360.87b6332e.svg";